import React, { useEffect, useState } from 'react';
import { getBuzones, crearBuzon, editarBuzon, borrarBuzon, probarBuzon } from '../services/api';

// Modal de administración de buzones IMAP, compartido por Facturas recibidas
// (soloTipo="factura") y Gastos / Caja menor (soloTipo="caja_menor").
// Si soloTipo es null, administra ambos tipos con un selector.
export default function BuzonesModal({ soloTipo, onClose, onFlash }) {
  const tipoFijo = soloTipo === 'caja_menor' || soloTipo === 'factura' ? soloTipo : null;
  const nuevo = () => ({ host: 'imap.gmail.com', port: 993, usuario: '', password: '', mailbox: 'INBOX', tipo: tipoFijo || 'factura' });

  const [lista, setLista] = useState([]);
  const [ed, setEd] = useState(null);   // { id?, form }
  const [busy, setBusy] = useState(false);
  const [prueba, setPrueba] = useState(null);
  const [flash, setFlash] = useState(null); // { ok, msg }

  const aviso = (ok, msg) => { setFlash({ ok, msg }); if (onFlash) onFlash(ok, msg); setTimeout(() => setFlash(null), 4000); };

  const load = () => getBuzones().then(r => {
    const data = tipoFijo ? r.data.filter(b => (b.tipo || 'factura') === tipoFijo) : r.data;
    setLista(data);
  }).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const guardar = async () => {
    const f = ed.form;
    if (!f.usuario.trim() || (!ed.id && !f.password)) return aviso(false, 'Correo y contraseña de aplicación son requeridos');
    setBusy(true);
    try {
      const payload = { host: f.host, port: f.port, usuario: f.usuario, mailbox: f.mailbox, tipo: tipoFijo || f.tipo || 'factura', ...(f.password ? { password: f.password } : {}) };
      if (ed.id) await editarBuzon(ed.id, payload); else await crearBuzon(payload);
      setEd(null); load(); aviso(true, '✅ Buzón guardado');
    } catch (e) { aviso(false, '❌ ' + (e.response?.data?.error || 'No se pudo guardar')); }
    finally { setBusy(false); }
  };
  const borrar = async (b) => { if (!window.confirm(`¿Eliminar el buzón ${b.usuario}?`)) return; try { await borrarBuzon(b.id); load(); } catch (e) {} };
  const probar = async () => {
    setPrueba('...'); setBusy(true);
    try {
      const f = ed.form;
      const body = ed.id && !f.password ? { id: ed.id } : { host: f.host, port: f.port, usuario: f.usuario, password: f.password, mailbox: f.mailbox };
      const { data } = await probarBuzon(body);
      setPrueba(data.ok ? `✅ Conexión OK · ${data.mensajes} mensajes en el buzón` : `❌ ${data.error}`);
    } catch (e) { setPrueba('❌ ' + (e.response?.data?.error || 'Error')); }
    finally { setBusy(false); }
  };

  const esCaja = tipoFijo === 'caja_menor';
  const titulo = esCaja ? 'Buzón de caja menor' : tipoFijo === 'factura' ? 'Buzones de facturas recibidas' : 'Buzones de recepción';
  const ayuda = esCaja
    ? 'Correo donde tu equipo reenvía o deja los tiquetes y recibos de caja menor. El sistema los revisa cada pocos minutos y crea un gasto en borrador leído por IA, que luego revisas y confirmas. Para Gmail usa una contraseña de aplicación (no la normal).'
    : 'Correos donde tus proveedores dejan las facturas. El sistema los revisa cada pocos minutos y carga las facturas automáticamente. Para Gmail usa una contraseña de aplicación (no la normal).';

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={{ ...s.modal, width: 560, maxHeight: '92vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
        <h3 style={s.modalTitle}>{titulo}</h3>
        <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 12 }}>{ayuda}</div>
        {flash && <div style={{ ...s.flash, background: flash.ok ? '#064e3b' : '#3f1d1d', color: flash.ok ? '#6ee7b7' : '#fca5a5' }}>{flash.msg}</div>}

        {!ed && <>
          <div style={s.card}><table style={{ ...s.table, minWidth: 0 }}>
            <thead><tr>{['Correo', 'Servidor', 'Estado', ''].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
            <tbody>
              {lista.length === 0 && <tr><td colSpan={4} style={s.empty}>Sin buzones configurados.</td></tr>}
              {lista.map(b => (
                <tr key={b.id}>
                  <td style={{ ...s.td, color: '#e2e8f0' }}>{b.usuario}{!tipoFijo && <div><span style={{ ...s.badge, marginTop: 4, background: b.tipo === 'caja_menor' ? '#f59e0b22' : '#3b82f622', color: b.tipo === 'caja_menor' ? '#fbbf24' : '#60a5fa' }}>{b.tipo === 'caja_menor' ? 'Caja menor' : 'Facturas FE'}</span></div>}</td>
                  <td style={s.td}>{b.host}:{b.port}</td>
                  <td style={s.td}><span style={{ ...s.badge, background: b.activo ? '#10b98122' : '#64748b22', color: b.activo ? '#10b981' : '#94a3b8' }}>{b.activo ? 'Activo' : 'Inactivo'}</span></td>
                  <td style={s.td}><button style={s.link} onClick={() => setEd({ id: b.id, form: { ...nuevo(), ...b, password: '' } })}>Editar</button><button style={{ ...s.link, color: '#fca5a5' }} onClick={() => borrar(b)}>Eliminar</button></td>
                </tr>
              ))}
            </tbody>
          </table></div>
          <div style={s.modalBtns}><button style={s.btnGhost} onClick={onClose}>Cerrar</button><button style={s.btn} onClick={() => { setEd({ form: nuevo() }); setPrueba(null); }}>+ Nuevo buzón</button></div>
        </>}

        {ed && <>
          <label style={s.lbl}>Correo de recepción</label>
          <input style={{ ...s.in, marginBottom: 10 }} value={ed.form.usuario} onChange={e => setEd({ ...ed, form: { ...ed.form, usuario: e.target.value } })} placeholder={esCaja ? 'cajamenor@tuempresa.com' : 'facturacion@tuempresa.com'} />
          <label style={s.lbl}>Contraseña de aplicación {ed.id && <span style={{ color: '#64748b' }}>(dejar vacío para no cambiarla)</span>}</label>
          <input type="password" style={{ ...s.in, marginBottom: 10 }} value={ed.form.password} onChange={e => setEd({ ...ed, form: { ...ed.form, password: e.target.value } })} placeholder="••••••••••••" />
          {!tipoFijo && <>
            <label style={s.lbl}>¿Qué llega a este buzón?</label>
            <select style={{ ...s.in, marginBottom: 4 }} value={ed.form.tipo || 'factura'} onChange={e => setEd({ ...ed, form: { ...ed.form, tipo: e.target.value } })}>
              <option value="factura">Facturas de proveedores (XML/ZIP) — recepción FE</option>
              <option value="caja_menor">Caja menor — tiquetes/recibos escaneados (foto o PDF)</option>
            </select>
          </>}
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: 10 }}>
            <div><label style={s.lbl}>Servidor IMAP</label><input style={s.in} value={ed.form.host} onChange={e => setEd({ ...ed, form: { ...ed.form, host: e.target.value } })} /></div>
            <div><label style={s.lbl}>Puerto</label><input type="number" style={s.in} value={ed.form.port} onChange={e => setEd({ ...ed, form: { ...ed.form, port: +e.target.value } })} /></div>
            <div><label style={s.lbl}>Carpeta</label><input style={s.in} value={ed.form.mailbox} onChange={e => setEd({ ...ed, form: { ...ed.form, mailbox: e.target.value } })} /></div>
          </div>
          {prueba && <div style={{ marginTop: 10, fontSize: 13, color: prueba.startsWith('✅') ? '#6ee7b7' : '#fca5a5' }}>{prueba}</div>}
          <div style={{ ...s.modalBtns, justifyContent: 'space-between' }}>
            <button style={s.btnGhost} disabled={busy} onClick={probar}>Probar conexión</button>
            <div style={{ display: 'flex', gap: 10 }}>
              <button style={s.btnGhost} onClick={() => setEd(null)}>Cancelar</button>
              <button style={s.btn} disabled={busy} onClick={guardar}>{busy ? 'Guardando…' : 'Guardar'}</button>
            </div>
          </div>
        </>}
      </div>
    </div>
  );
}

const s = {
  btn: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  btnGhost: { background: 'transparent', color: '#94a3b8', border: '1px solid #334155', borderRadius: 8, padding: '10px 18px', fontSize: 14, cursor: 'pointer' },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: { textAlign: 'left', padding: '10px 12px', color: '#64748b', fontSize: 11, textTransform: 'uppercase', letterSpacing: .5, borderBottom: '1px solid #334155', background: '#0f172a', whiteSpace: 'nowrap' },
  td: { padding: '10px 12px', color: '#94a3b8', borderBottom: '1px solid #1e293b' },
  empty: { padding: 30, textAlign: 'center', color: '#64748b' },
  badge: { display: 'inline-block', padding: '2px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' },
  link: { background: 'none', border: 'none', color: '#60a5fa', cursor: 'pointer', fontSize: 13, padding: 0, marginRight: 10 },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 },
  modal: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 18, maxWidth: '96vw', color: '#cbd5e1' },
  modalTitle: { color: '#f1f5f9', fontSize: 17, fontWeight: 700, margin: '0 0 12px' },
  modalBtns: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 12 },
  lbl: { display: 'block', color: '#94a3b8', fontSize: 12, marginBottom: 5 },
  in: { width: '100%', boxSizing: 'border-box', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '8px 11px', color: '#f1f5f9', fontSize: 13.5 },
  flash: { padding: '8px 12px', borderRadius: 8, fontSize: 13, marginBottom: 12 },
};
